<template>
    <div class="wrapper w-100">
        <div class="row mb-4">
            <div class="col-12">
                <skeleton-wrapper :is-loading="isLoading">
                    <template v-slot:skeleton>
                        <company-dashboard-skeleton />
                    </template>
                    <template v-slot:content>
                        <text-image-card
                            :title="data.service"
                            :description="data.description"
                            :buttonText="trans('home.explore')"
                            :illustration="data.illustration.url"
                            @ctaClicked="accessService(data.id, 'utility', 'company-dashboard')"
                        />
                    </template>
                </skeleton-wrapper>    
            </div>
        </div>
    </div>
</template>

<script>
    import roleMixin from "../../mixins/roleMixin";
    import TextImageCard from "../../molecules/cards/TextImageCard";
    import SkeletonWrapper from "../../organisms/SkeletonWrapper";
    import CompanyDashboardSkeleton from "../../molecules/skeletons/CompanyDashboardSkeleton";

    export default {
        name: "CompanyDashboard",
        mixins:[roleMixin],
        components: {
            TextImageCard,
            SkeletonWrapper,
            CompanyDashboardSkeleton
        },
        data(){
            return{
                isLoading: true,
                data: [],
            }
        },
        mounted() {
            this.$axios.get("/api/rest/home/companyDashboardService")
                .then(res => {
                    this.isLoading = false;
                    this.data = res.data.analytics;
            })
            .catch(err => {
                this.isLoading = false;
                console.log(err);
            });
        },
        methods:{
            
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        min-height: 270px;
    }
</style>